import {
  onboardingExerciseTypeOptions,
  programExerciseTypeOptions,
  exerciseTypeLabelById,
} from "@/lib/exercise-types";

export const genderOptions = [
  { value: "female", label: "Female" },
  { value: "male", label: "Male" },
  { value: "non-binary", label: "Non-binary" },
  { value: "prefer-not-to-say", label: "Prefer not to say" },
];

export const motivationOptions = [
  { id: "lose-weight", label: "Lose Weight", icon: "🎯" },
  { id: "build-muscle", label: "Build Muscle", icon: "💪" },
  { id: "increase-strength", label: "Increase Strength", icon: "🏋️" },
  { id: "improve-health", label: "Improve Health", icon: "❤️" },
  { id: "boost-energy", label: "Boost Energy", icon: "⚡" },
  { id: "reduce-stress", label: "Reduce Stress", icon: "🧘" },
  { id: "sport-performance", label: "Sport Performance", icon: "🏃" },
];

export const workoutFrequencyOptions = [
  { value: "2-times", label: "2 times per week" },
  { value: "3-times", label: "3 times per week" },
  { value: "4-times", label: "4 times per week" },
  { value: "5-plus", label: "5+ times per week" },
];

export const exerciseTypeOptions = [
  // NOTE: This list is intentionally the onboarding list.
  // Use `programExerciseTypeOptions` for program creation/editing UIs.
  ...onboardingExerciseTypeOptions,
];

export { programExerciseTypeOptions };

export const timeframeOptions = [
  { value: "1-month", label: "1 month" },
  { value: "3-months", label: "3 months" },
  { value: "6-months", label: "6 months" },
  { value: "12-months", label: "12 months" },
];

export const activityLevelOptions = [
  { value: "sedentary", label: "Sedentary", description: "I do little to no structured physical activity or exercise" },
  { value: "lightly-active", label: "Lightly Active", description: "I walk or move casually during the day and may do light activity (e.g., Yoga, stretching, or short walks) 2-3 times per week" },
  { value: "moderately-active-cardio", label: "Moderately Active (Cardio Focused)", description: "I engage in cardio-based activities (e.g., running, biking, group fitness classes) 2-3x per week with minimal or no strength training" },
  { value: "moderately-active-strength", label: "Moderately Active (Strength-focused)", description: "I perform strength training (e.g., weights, bodyweight exercises) 2-3 times per week but little to no cardio" },
  { value: "very-active", label: "Very Active", description: "I combine both cardio and strength focused training 4-5x per week consistently" },
  { value: "fully-active", label: "Fully Active / Athletic", description: "I train almost daily with a well-rounded routine that includes strength, cardio, mobility and recovery practises" },
];

export const workoutDurationOptions = [
  { value: "30-min", label: "30 min" },
  { value: "45-min", label: "45 min" },
  { value: "60-plus-min", label: "60+ min" },
];

export const additionalServiceOptions = [
  { id: "find-gym", label: "Find a gym" },
  { id: "workout-gear", label: "Workout apparel" },
  { id: "equipment", label: "Home Equipment" },
  { id: "gym-buddies", label: "Find Gym Buddies" },
];

export const labels = {
  motivation: Object.fromEntries(motivationOptions.map(o => [o.id, o.label])) as Record<string,string>,
  workoutFrequency: Object.fromEntries(workoutFrequencyOptions.map(o => [o.value, o.label])) as Record<string,string>,
  workoutDuration: Object.fromEntries(workoutDurationOptions.map(o => [o.value, o.label])) as Record<string,string>,
  // Include ALL exercise type labels (onboarding + program extended + legacy).
  exerciseType: exerciseTypeLabelById as Record<string, string>,
  timeframe: Object.fromEntries(timeframeOptions.map(o => [o.value, o.label])) as Record<string,string>,
  activityLevel: Object.fromEntries(activityLevelOptions.map(o => [o.value, o.label])) as Record<string,string>,
  service: Object.fromEntries(additionalServiceOptions.map(o => [o.id, o.label])) as Record<string,string>,
};


